import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import FieldsController from '../../../controllers/FieldsController';
import type BaseField from '../../../fields/BaseField';
import EditableTextField from '../../EditableTextField';
import FieldEditors from '../../fields/editors';
import styles from '../../../styles.module.css';
import AttributeRow from '../attributes/AttributeRow';

interface EditFieldProps {
  field: BaseField;
}

const EditField: React.FC<EditFieldProps> = ({ field }) => {
  const controller = useController(FieldsController);
  const Editor = FieldEditors[field.type];

  return (
    <AttributeRow>
      <div className={styles.itemList}>
        <div
          className={styles.flexRow}
          style={{ alignItems: 'center', gap: 'var(--spacer-3)' }}
        >
          <div style={{ flex: 1 }}>
            <EditableTextField
              initialValue={field.name}
              inplace
              onChange={value =>
                controller.actionUpdateField(field, { name: value })
              }
              style={{ width: '100%' }}
            />
          </div>

          {!field.internal && (
            <aha-button
              class={`p-0 ${styles.actionButton}`}
              kind='plain'
              onClick={() => {
                if (
                  confirm(
                    `Are you sure you want to delete the ${field.name} field?`
                  )
                ) {
                  controller.actionRemoveField(field);
                }
              }}
            >
              <i className='fa-regular fa-trash-can' />
            </aha-button>
          )}

          <aha-switch
            active={!field.hidden || null}
            class={styles.actionButton}
            onClick={(e: React.MouseEvent<HTMLAhaSwitchElement>) =>
              controller.actionUpdateField(field, {
                hidden: !e.currentTarget.active,
              })
            }
          />
        </div>

        {Editor && (
          <div
            className={styles.flexRow}
            style={{ alignItems: 'center', gap: 'var(--spacer-3)' }}
          >
            <Editor field={field} />
          </div>
        )}
      </div>
    </AttributeRow>
  );
};

export default ApplicationView(EditField);
